import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
